/**
 * Dependencies.
 */
import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

import DocumentRouter from '@/modules/document/router';
// import EvaluationRouter from '@/modules/evaluation/router';
import AppScene from '@/modules/main/scenes/app/app.scene.vue';
import NotFoundScene from '@/modules/main/scenes/not-found/not-found.scene.vue';
import UnauthorizedScene from '@/modules/main/scenes/unauthorized/unauthorized.scene.vue';
import ServicePointRouter from '@/modules/service-point/router';
import SurveyRouter from '@/modules/survey/router';
import TrackingOldRouter from '@/modules/tracking-old/router';
import TrackingRouter from '@/modules/tracking/router';
import InvalidTrackingNumberScene from '@/modules/tracking/scenes/invalid/invalid-tracking-number.scene.vue';

/**
 * Use router.
 */
Vue.use(VueRouter);

/**
 * Routes.
 */
const routes: Array<RouteConfig> = [
  // Documents.
  ...DocumentRouter,

  // Service point.
  ...ServicePointRouter,

  // Evalution and Tracking.
  {
    children: [
      // ...EvaluationRouter,
      ...SurveyRouter,
      ...TrackingOldRouter,
      ...TrackingRouter
    ],
    component: AppScene,
    name: 'App',
    path: '/',
    redirect: { name: 'NotFound' }
  },
  {
    component: InvalidTrackingNumberScene,
    name: 'InvalidTrackingNumber',
    path: '/invalid-tracking'
  },
  {
    component: NotFoundScene,
    name: 'NotFound',
    path: '/not-found'
  },
  {
    component: UnauthorizedScene,
    name: 'Unauthorized',
    path: '/unauthorized'
  },
  {
    path: '*',
    redirect: { name: 'NotFound' }
  }
];

/**
 * New router instance.
 */
const router = new VueRouter({
  mode: 'history',
  routes
});

/**
 * Export `router`.
 */
export default router;
